import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useTrainingAuth } from '../context/TrainingAuthContext';

/**
 * Entry point for the Training Module.
 * Checks training auth (not inspection auth) and redirects appropriately.
 */
const TrainingModule = () => {
  const { isTrainingAuthenticated, trainingUser, loadingTraining } = useTrainingAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loadingTraining) return;

    if (!isTrainingAuthenticated) {
      navigate('/training-login', { replace: true });
      return;
    }

    const role = trainingUser?.role;
    if (['training_coordinator', 'training_document_controller'].includes(role)) {
      navigate('/training/coordinator', { replace: true });
    } else {
      navigate('/training/reviewer', { replace: true });
    }
  }, [isTrainingAuthenticated, trainingUser, loadingTraining, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
      <Spinner animation="border" variant="success" />
    </div>
  );
};

export default TrainingModule;
